module.exports = __webpack_public_path__ + "img/img_sec_ticketinfo_01.bc093b3f.png";